import Avatar from 'components/shared/Avatar/Avatar';
import Hr from 'components/shared/Hr/Hr';
import Icon from 'components/shared/Icon/Icon';

const SupportAndContactReview = ({ data, navigateToSubstep }) => {
  const supportData = data?.substeps?.find(
    (substep) => substep.code === 'onboarding__support_and_contact__support_and_contact'
  )?.data;
  const contactDataArray = [
    { key: 'consultant', label: 'Consultant', contact: supportData?.consultant },
    {
      key: 'onboardingArchitect',
      label: 'Onboarding Architect',
      contact: supportData?.onboardingArchitect
    },
    {
      key: 'insideRepresentative',
      label: 'Inside Representative',
      contact: supportData?.insideRepresentative
    }
  ]
    .filter((item) => item.contact)
    .map((item) => ({
      id: item.contact?.id,
      role: item.label,
      name: [item.contact?.firstName, item.contact?.lastName].filter(Boolean).join(' ') || 'N/A',
      email: item.contact?.email,
      phone: item.contact?.phone
    }));

  return (
    <div>
      {data?.substeps?.map((substep) => {
        return (
          <div key={substep.id}>
            <div className="mb-4 flex items-center gap-2 px-5 pt-5">
              <p className="font-600">{substep.name}</p>
              {substep.status === 'Completed' || substep.status === 'Confirmed' ? (
                <Icon icon="check-linear" color="success" />
              ) : (
                <Icon icon="close-linear" color="danger" />
              )}
              <Icon
                icon="link-linear"
                className="cursor-pointer"
                onClick={() => navigateToSubstep(substep.code)}
              />
            </div>
            {substep.data && (
              <div className="space-y-2 px-5 pb-5">
                <div className="flex justify-between border-b border-neutral-100 pb-2">
                  <span className="text-sm font-500 text-neutral-600">Status</span>
                  <span className="text-sm text-neutral-900">TBD</span>
                </div>
              </div>
            )}
            <Hr className="my-0" />
            <div className="flex w-full">
              {contactDataArray.map((contact) => (
                <div
                  key={contact.id}
                  className="w-full border-b-0 border-l-0 border-r border-t-0 border-solid border-neutral-200 p-5 last:border-r-0">
                  <p className="mb-6 font-500 text-neutral-900">{contact.role}</p>
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-2">
                      <Avatar size="small" fullName={contact.name} />
                      <p className="text-sm text-neutral-900">{contact.name}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon icon="mail-mono" />
                      <p className="text-sm text-neutral-900">{contact.email}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <Icon icon="call-calling-mono" />
                      <p className="text-sm text-neutral-900">
                        {!!contact.phone ? contact.phone : 'N/A'}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {contactDataArray.length === 0 && (
              <div className="p-5">
                <div className="flex justify-between border-b border-neutral-100">
                  <span className="text-sm font-500 text-neutral-600">Status</span>
                  <span className="text-sm text-neutral-900">
                    Wait for our staff to assign the support
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SupportAndContactReview;
